import {useEffect, useState} from "react";
import HeaderCustom from "../components/header-custom";
import Footer from "../components/footer";
import {Container, Row, Col, Spinner} from "react-bootstrap";
import APICallService from "../api/apiCallService";
import {TNC} from "../api/apiEndPoints";

const PrivacyPolicy = () => {
    const [privacyData, setPrivacyData] = useState<string>("");
    const [fetchLoading, setFetchLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            setFetchLoading(true);
            const apiService = new APICallService(TNC, "", "", "");
            const response = await apiService.callAPI();
            // console.log("response ", response);

            if (response) {
                setPrivacyData(response?.data);
            }
            setFetchLoading(false);
        };
        fetchData();
    }, []);

    return (
        <>
            <HeaderCustom showButton={true} />
            <div
                style={{
                    minHeight: "85vh",
                    backgroundColor: "#fff",
                    color: "#000",
                    padding: "60px 0", // Increased padding for more vertical space
                }}
            >
                <Container className="mt-5">
                    <Row className="justify-content-center">
                        {/* Increased column width for broader content */}
                        <Col xs={12} sm={12} md={10} lg={10}>
                            <nav aria-label="breadcrumb" className="mb-4">
                                <ol className="breadcrumb justify-content-center">
                                    {/* Add breadcrumb items if needed */}
                                </ol>
                            </nav>
                            <h1 className="text-center my-5" style={{fontSize: "2.5rem"}}>
                                Terms & Conditions
                            </h1>
                            {fetchLoading ? (
                                <div className="text-center mt-5">
                                    <Spinner animation="border" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </Spinner>
                                </div>
                            ) : (
                                <div
                                    className="policy-content"
                                    style={{
                                        lineHeight: "1.8", // Improved readability with line spacing
                                        fontSize: "1.1rem", // Slightly larger text
                                        maxWidth: "100%", // Ensures content spans the full column width
                                        padding: "0 20px", // Adds horizontal padding for breathing room
                                    }}
                                    dangerouslySetInnerHTML={{__html: privacyData}}
                                />
                            )}
                        </Col>
                    </Row>
                </Container>
            </div>
            <Footer pageType="privacy-policy" />
        </>
    );
};

export default PrivacyPolicy;
